<div [ngStyle]="{ 'max-height': widgetMaxHeight+'px' }" class="machine-view-widget">
    <div class="model-view-container">
    
        <div class="control-buttons d-flex gap-2">
            <dx-button text="Stop" icon="square" [disabled]="!(supplierState | async) || !(isFenixActionEnabled(getCmdRole('SmStopCmd')) | async)"  (click)="doCommand('SmStopCmd')" class="stop-button"></dx-button>
            <dx-button text="Start" icon="video" [disabled]="!(supplierState | async) || !(isFenixActionEnabled(getCmdRole('SmSelectCmd')) | async)" (click)="startConfirmDialog()" class="start-button"></dx-button>
            <ng-container *ngIf="isSelecting">
                <dx-button text="Empty" [disabled]="!(supplierState | async) || !(isFenixActionEnabled(emptyingRole) | async)" *ngIf="!isEmpting" icon="trash" (onClick)="setEmptyOnSupplier(true)"></dx-button>
                <div class="orange-empty-button" *ngIf="isEmpting">
                    <dx-button [disabled]="!(supplierState | async) || !(isFenixActionEnabled(emptyingRole) | async)" text="Empty" icon="trash" (onClick)="setEmptyOnSupplier(false)"></dx-button>
                </div>
            </ng-container>
        </div>
    
        <div class="canvas" #canvas></div>
    </div>
</div>
